import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import { useSessionStore } from '@/stores/session'
import VuePlyr from 'vue-plyr'
import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-thumbnail.css'
import 'vue-plyr/dist/vue-plyr.css'
import noRightClick from './directives/noRightClick';

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)
app.use(VuePlyr, {
  plyr: {}
})
app.directive('no-right-click', noRightClick);
app.mount('#app')

// ✅ Use store after mount + nextTick
nextTick(() => {
  const session = useSessionStore()
  session.loadUser()
})
